import { useEffect } from 'react';
import { COUNTRY_COUNT, LOCATIONS, PHOTO_COUNT, YEAR_RANGE } from '../data/locations';
import { usePinHighlight } from '../state/pinHighlight';
import { Attribution } from './Attribution';
import { PlaceIndex } from './PlaceIndex';
import { PlacePreview } from './PlacePreview';

export function IntroPanel() {
  const coarse = typeof matchMedia !== 'undefined' && matchMedia('(pointer: coarse)').matches;

  useEffect(() => () => usePinHighlight.getState().clearAll(), []);

  return (
    <div className="@container flex min-h-full flex-col px-6 pt-7 lg:h-full lg:px-10 lg:pt-9">
      <p className="whitespace-nowrap font-mono text-[10px] uppercase tracking-[0.16em] text-[#f2c66d]/90 @max-[314px]:tracking-[0.06em]">
        {LOCATIONS.length} places · {COUNTRY_COUNT} countries · {PHOTO_COUNT} photographs
      </p>
      <h1 className="mt-2 text-[32px] font-[580] leading-[1.05] tracking-[-0.02em] lg:text-[40px] 2xl:text-[44px]">
        Places I've been
      </h1>
      <p className="mt-2.5 max-w-[44ch] text-[15px] leading-[1.6] text-white/70">
        A collection of places remembered through photographs. Rotate the globe and choose a city.
      </p>

      <PlacePreview coarse={coarse} />

      <PlaceIndex />

      <div className="mt-5 flex flex-wrap items-end justify-between gap-x-6 gap-y-1 border-t border-white/10 pb-7 pt-3 lg:mt-2.5 lg:pb-4">
        <dl className="flex shrink-0 gap-11">
          <div>
            <dt className="font-mono text-[10px] uppercase leading-[15px] tracking-[0.14em] text-white/55">Places</dt>
            <dd className="mt-0.5 whitespace-nowrap text-[20px] font-[550] leading-[1.2] tabular-nums">{LOCATIONS.length}</dd>
          </div>
          <div>
            <dt className="font-mono text-[10px] uppercase leading-[15px] tracking-[0.14em] text-white/55">Years</dt>
            <dd className="mt-0.5 whitespace-nowrap text-[20px] font-[550] leading-[1.2] tabular-nums">{YEAR_RANGE}</dd>
          </div>
        </dl>
        <Attribution className="ml-auto max-w-[124px] text-right" />
      </div>
    </div>
  );
}
